import { BaseModel } from "./base.model";

export interface PersonInfo extends BaseModel {
  firstName: string;
  lastName: string;
  cvUpdateDate: Date;
  email: string;
  inactive: boolean;
  image: File | string;
  imageName: string;
  imagePath: string;
  technologies?: string[];
  certificates?: string[];

  availabilityDate?: string;
  finalScoring?: number;
  location?: string;
  officeLocationName?: string;
  officeLocationId?: number;
  employeeId?: number;
  currentPositionName?: string;
  currentProjectName?: string;
  currentCostCenterName?: string;
  currentWorkScheduleName?: string;
  allocationPercent?: number;
  workStartDate?: string;
  workEndDate?: string;
  contractTypeName?: string;
}

export interface Person extends PersonInfo {
  positions?: string[];
  roles?: string[];
}

export interface AppliedFilterInfo {
  matchedTechnologies: { [key: string]: string[] };
  matchedCertificates: { [key: string]: string[] };
  textSearchKeywords: string[];
  cleanedKeywords: { [key: string]: string };
}

export interface PersonsPage {
  allDataCount: number;
  page: PersonInfo[];
  pageIndex: number;
  appliedFilters?: AppliedFilterInfo;
}

export enum SortDirection {
  Invalid = 0,
  Ascending = 1,
  Descending = 2,
}

export enum FilteringOperator {
  NoN = 0,
  And = 1,
  Or = 2,
}
